<template>
  <div>
    <TypeNav />
    <!-- <ListContainer />
    <Recommend /> -->
    <Rank />
    <!-- <Like /> -->
    <Floor v-for="floor in floorList" :key="floor.id" :list="floor" />
    <Brand />
  </div>
</template>

<script>
// import ListContainer from "./ListContainer";
// import Recommend from "./Recommend";
import Rank from "./Rank";
// import Like from "./Like";
import Floor from "./Floor";
import Brand from "./Brand";
// import { mapState } from 'vuex'

export default {
  components: { 
    // ListContainer, 
    // Recommend, 
    Rank, Floor, Brand },
  mounted() {
    // // 获取floor数据
    // this.$store.dispatch('getFloorList')
    // this.$store.dispatch('getUserInfo')
  },
  computed: {
    // ...mapState({
    //   floorList: state => state.home.floorList
    // })
  },
};
</script>

<style>

</style>